module.exports = __webpack_public_path__ + "img/rapide.bfe86b3f.png";